




































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueProductForm from '@/components/Shared/SaascadaVueProductForm';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import DepositAccountSummary from "@/models/Accounts/DepositAccounts/DepositAccountSummary";
import BuySellFXRequest from '@/models/Accounts/DepositAccounts/Wallets/BuySellFXRequest';
import Wallet from '@/models/Accounts/DepositAccounts/Wallets/Wallet';

@Component({ name: 'FXSummary', components: { FieldLabel } })
export default class extends SaascadaVueProductForm {

    @Prop({required: true})
    account: DepositAccountSummary;

    @Prop({required: true})
    buySellFXRequest: BuySellFXRequest;

    get sourceWalletName() {
        if (!this.buySellFXRequest.sourceWalletId) {
            return Wallet;
        }
        else {
            const wallet = this.account.wallets.find(wallet => wallet.id === this.buySellFXRequest.sourceWalletId);
            return wallet.default ? "Default Wallet" : wallet.name;
        }
    }

    get destinationWalletName() {
        if (!this.buySellFXRequest.destinationWalletId) {
            return Wallet;
        }
        else {
            const wallet = this.account.wallets.find(wallet => wallet.id === this.buySellFXRequest.destinationWalletId);
            return wallet.default ? "Default Wallet" : wallet.name;
        }
    }

}
